import { cn } from "@/lib/utils";
import { ContainerProps, GridItemProps, GridProps } from "./Grid.model";

export const Container = ({
  children,
  className,
  fluid = true,
  as: Component = "div",
}: ContainerProps) => {
  return (
    <Component
      className={cn("mx-auto w-full", !fluid && "container", className)}
    >
      {children}
    </Component>
  );
};

export const Grid = ({
  children,
  className,
  as: Component = "div",
  hasPadding = true,
}: GridProps) => {
  return (
    <Component
      className={cn(
        "grid w-full",
        "grid-cols-[var(--grid-template-columns-sm)] gap-x-[var(--grid-column-gap-mobile)] gap-y-[var(--grid-row-gap-mobile)]",
        "md:grid-cols-[var(--grid-template-columns-md)] md:gap-x-[var(--grid-column-gap-tablet)] md:gap-y-[var(--grid-row-gap-tablet)]",
        "lg:grid-cols-[var(--grid-template-columns-lg)] lg:gap-x-[var(--grid-column-gap-desktop)] lg:gap-y-[var(--grid-row-gap-desktop)]",
        hasPadding &&
          "p-[var(--grid-column-gap-mobile)] md:p-[var(--grid-column-gap-tablet)] lg:p-[var(--grid-column-gap-desktop)]",
        className,
      )}
    >
      {children}
    </Component>
  );
};

export const GridItem = ({
  children,
  className,
  span,
  as: Component = "div",
}: GridItemProps) => {
  const getSpanClasses = () => {
    const classes = [];

    if (span?.mobile) {
      classes.push(`col-span-${span.mobile}`);
    }

    if (span?.tablet) {
      classes.push(`md:col-span-${span.tablet}`);
    }

    if (span?.desktop) {
      classes.push(`lg:col-span-${span.desktop}`);
    }

    return classes.join(" ");
  };

  return (
    <Component className={cn(getSpanClasses(), className)}>
      {children}
    </Component>
  );
};

// Export individual components
export default Grid;
